module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Products")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.product.name))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id) + "/fw_updates")
    }
  }, [_vm._v("Firmware updates")])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Version")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.version),
      expression: "fields.version"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^\d{1,3}\.\d{1,3}(?:\.\d{1,6})?$/
        }
      }),
      expression: "{rules: {required: true, regex: /^\\d{1,3}\\.\\d{1,3}(?:\\.\\d{1,6})?$/}}"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('version')
    },
    attrs: {
      "name": "version",
      "type": "text",
      "placeholder": "1.0.2",
      "data-vv-as": "Version"
    },
    domProps: {
      "value": (_vm.fields.version)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "version", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('version')),
      expression: "veeErrors.has('version')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('version')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.description),
      expression: "fields.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'textarea': true, 'is-danger': _vm.veeErrors.has('description')
    },
    attrs: {
      "name": "description",
      "type": "text",
      "placeholder": "Some description here",
      "data-vv-as": "Description"
    },
    domProps: {
      "value": (_vm.fields.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('description')),
      expression: "veeErrors.has('description')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('description')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Firmware file")]), _vm._v(" "), _c('div', {
    staticClass: "file"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'file-input': true, 'is-danger': _vm.veeErrors.has('file1')
    },
    attrs: {
      "name": "file1",
      "type": "file",
      "data-vv-as": "Firmware file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "file-cta"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "file-label"
  }, [_vm._v(_vm._s(_vm.filename))])])])]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Must be a binary file.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('file1')),
      expression: "veeErrors.has('file1')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('file1')))])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    class: {
      'button': true, 'is-primary': true, 'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Upload")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id) + "/fw_updates"),
      "exact": ""
    }
  }, [_vm._v("Cancel")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Firmware upload")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a9f7655"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FwUpdates/FwUpdateForm.vue
// module id = 209
// module chunks = 1